<script>
import {formatZonedDateTime} from "@/baseUtils";
import {proposalStatusText} from "@/utils/ProposalUtils";
import BaseAvatar from "@/components/BaseAvatar/BaseAvatar.vue";
import i18n from "@/i18n";

export default {
  name: "ProposalListItem",
  props: {
    itemData: {
      type: Object
    }
  },
  components: {
    BaseAvatar
  },
  computed: {
    proposalStatusClass() {
      const proposalStatus = this.itemData.extraAttributes.status;
      let statusClassName = '';

      if (proposalStatus === 'REJECTED') {
        statusClassName = 'rejected';
      } else {
        statusClassName = 'current';
      }

      return statusClassName;
    },
    proposalStatus() {
      return proposalStatusText(this.itemData.extraAttributes.status, this.itemData.forum.name, this.itemData.extraAttributes.committeeType);
    },
    forumImgSrc() {
      return `/viewimage?type=forum&sh=${this.itemData.forum.largeImgHash}`;
    },
    itemDateLabel() {
      return this.itemData.version > 1 ? i18n.global.t('mainSearch.updated') : i18n.global.t('mainSearch.registered');
    },
    proposalCreateDate() {
      return formatZonedDateTime(this.itemData.dateTime);
    },
  },
}
</script>

<template>
  <div class="proposal-list-item">
    <div class="forum-label">
      <div v-if="itemData.forum.id === 1"
           class="forum-label__icon riksdagen-icon"></div>
      <img v-else :src="forumImgSrc" class="forum-label__icon"/>
      {{itemData.forum.name}}
    </div>
    <router-link :to="{name: 'ProposalView', params: {id: itemData.id}}"
                 target="_blank"
                 class="proposal-header"
    >{{itemData.title}}</router-link>
    <div class="proposal-info">
      <div class="proposal-info__row">
        <div class="proposal-info-status" :class="proposalStatusClass">
          {{proposalStatus}}
        </div>
      </div>
      <div class="proposal-info__row">
        <span class="proposal-info-text">
          {{itemDateLabel}} {{proposalCreateDate}}
        </span>
        <font-awesome-icon :icon="['fas', 'circle']"
                           class="dot-separator"
        />

        <span class="proposal-info-text">{{itemData.issueNumber}}</span>
      </div>
      <div class="proposal-info__row">
        <span class="proposal-info-label">
          {{$t('mainSearch.proposal.proposer')}}
        </span>
        <span class="proposal-info-text">{{itemData.proposer.name}}</span>
        <base-avatar  :size="'SM'"
                      class=""
                      :img-hash="itemData.proposer.largeImgHash"
        />
      </div>
      <div class="d-flex">
        <span class="proposal-info-label">
          {{$t('mainSearch.proposal.subjects')}}
        </span>
        <div class="subject-list">
             <span v-for="(subject, index) of itemData.subjects" class="subject-item"
                   :key="subject + index"
             >
              {{subject}}
               <font-awesome-icon v-if="(index + 1) !== itemData.subjects.length"
                                  :icon="['fas', 'circle']"
                                  class="dot-separator"
               />
            </span>
        </div>

      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.proposal-list-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 12px;
  position: relative;
  max-width: 600px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(79, 79, 79, .15);

  .forum-label {
    position: absolute;
    display: inline-block;
    padding: 0 22px 0 0;
    height: 24px;
    line-height: 24px;
    border-right: 1px solid #bbbbbb;
    margin: 0 10px 12px 0;
    background-color: #7835a6;
    color: #fff;
    left: 0;
    top: 12px;
    &:after {
      position: absolute;
      top: 0;
      right: -1px;
      content: '';
      width: 0;
      height: 0;
      border-top: 12px solid transparent;
      border-bottom: 12px solid transparent;
      border-right:12px solid #fff;
    }

    &__icon {
      display: block;
      float: left;
      vertical-align: middle;
      height: 16px;
      width: auto;
      margin: 4px 8px 0 6px;;

      &.riksdagen-icon {
        width: 22px;
        height: 15px;
        background: url("~@/assets/img/proposal/riksdagen-icon.svg"), no-repeat, center;
      }
    }
  }

  .proposal-header {
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
    display: block;
    padding: 35px 0 12px;
    color: #7835a6
  }

  .proposal-info {
    &__row {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
  }

  .proposal-info-status {
    padding: 5px 18px;
    margin-right: 15px;
    border-radius: 13.5px;
    color: #fff;
    font-size: 14px;
    font-weight: 600;

    &.current {
      background: #5786ff !important;
    }
    &.rejected {
      background: #de2364 !important;
    }
  }
  .proposal-info-label {
    display: inline-block;
    margin-right: 5px;
    font-weight: 600;
    color: #4f4f4f;
  }
  .proposal-info-text {
    display: inline-block;
    margin-right: 5px;
    font-size: 12px;
    color: #4f4f4f;
  }
  .subject-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .subject-item {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      font-size: 13px;
      color: #4f4f4f;
    }
  }

  .dot-separator {
    font-size: 3px;
    margin: 0 5px;
    color: #4f4f4f;
  }
}
</style>